import { EmployeesState } from "../../models/EmployeesState";

const sendPasswordSuccess = (state: EmployeesState) => {
    state.isLoading = false;
    state.isError = null;
    state.message = "Пароль працівника успішно відправлено";
    state.messageVisiable = true;
}

export default sendPasswordSuccess;